import {
  MeasurementData,
  WeatherAlertCurrentConditions,
} from 'features/weather/types';
import { convertToImperial } from 'features/weather/utils/dataConverters';
import { Dish } from 'types';
import { Weather } from 'types/models/Weather';

export const getWeatherAlerts = (
  dishes: Dish[],
  currentConditions: Weather | undefined,
  useImperial: boolean | null | undefined
): WeatherAlertCurrentConditions => {
  const newAlerts: WeatherAlertCurrentConditions = {};
  for (const dish of dishes) {
    if (!currentConditions) break;
    for (const alert of dish.weatherAlerts) {
      if (!alert.enabled) continue;
      const condition: number | null | undefined =
        currentConditions[alert.condition as MeasurementData];
      if (condition === null || condition === undefined) continue;
      if (condition > alert.warning) {
        if (!newAlerts[alert.condition]) {
          newAlerts[alert.condition] = [];
        }
        newAlerts[alert.condition] = [
          ...newAlerts[alert.condition],
          {
            warning: true,
            threshold: convertToImperial(
              alert.warning,
              alert.condition,
              useImperial
            ),
            dishName: dish.name ? dish.name : 'Unnamed Dish',
          },
        ];
      } else if (condition > alert.caution) {
        if (!newAlerts[alert.condition]) {
          newAlerts[alert.condition] = [];
        }
        newAlerts[alert.condition] = [
          ...newAlerts[alert.condition],
          {
            warning: false,
            threshold: convertToImperial(
              alert.caution,
              alert.condition,
              useImperial
            ),
            dishName: dish.name ? dish.name : 'Unnamed Dish',
          },
        ];
      }
    }
  }
  return newAlerts;
};

export const isWeatherAlerting = (
  dishes: Dish[],
  currentConditions: Weather | undefined,
  useImperial: boolean | null | undefined
): { warning: boolean; caution: boolean } => {
  const alertInfo = { warning: false, caution: false };
  for (const dish of dishes) {
    if (!currentConditions) break;
    for (const alert of dish.weatherAlerts) {
      if (!alert.enabled) continue;
      const condition: number | null | undefined =
        currentConditions[alert.condition as MeasurementData];
      if (condition === null || condition === undefined) continue;
      if (condition > alert.warning) {
        alertInfo.warning = true;
      } else if (condition > alert.caution) {
        alertInfo.caution = true;
      }
    }
    if (alertInfo.warning) return alertInfo;
  }
  return alertInfo;
};
